const DATA_TYPES = ['string', 'number', 'date', 'boolean', 'object']

export default DATA_TYPES
